import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FormModal } from '@ui-partents/Modal';
import {
  Input,
} from "reactstrap";
import styled from "styled-components";
import { TitleNoteCommon } from "../home/generate";
import { listChatGpt } from '@utils/dataDefault'
import Select from 'react-select'
import { toast } from "react-toastify";
import { apiCaller } from "@utils";

const WrapForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

const FormDate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const WrapStatement = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
`

const ErrorMessage = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 4px;
`;

const ModalNewExperiment = ({...props}) => {
  const { toggle, isOpen } = props
  const [isLoading, setIsLoading] = useState(false)

  //form
  const {
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      name: "",
      agent: listChatGpt[0]?.value,
      dialog: listChatGpt[0]?.value,
    }
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    const params = {
      Mode: "EngagementAgents",
      ServiceAgentId: 63,
      UserAgentId: 67,
      MaxStatements: data?.statement,
      Iterations: data?.iteration,
      Name: data?.name
    }
    apiCaller(`/api/monitoring/execute/`, "POST", params).then((res) => {
      if (res.status === 200) {
        toast.success("Execute chatbot successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setIsLoading(false);
        toggle()
      } else {
        setIsLoading(false);
        toggle()
      }
    });
  };

  return (
    <FormModal
      isOpen={isOpen}
      toggleModal={toggle}
      title="Create New Experiment"
      actionText={"Execute Experiment"}
      maxWidth="800px"
      onAction={handleSubmit(onSubmit)}
      isLoading={isLoading}
    >
      <form className="form-platform">
        <WrapForm>
          <FormDate className='w-100 mb-0'>
            <TitleNoteCommon
              dataFor={'periodName'} 
              title="Name" 
              content=""
            />
            <Controller
              name="name"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Input
                  type='text'
                  name='name'
                  placeholder=""
                />
              )}
            />
            {errors.name && <ErrorMessage>This is required.</ErrorMessage>}
          </FormDate>
          <FormDate className='w-100 mb-0'>
            <TitleNoteCommon
              dataFor={'agent'} 
              title="Agent" 
              content=""
            />
            <Controller
              name="agent"
              control={control}
              render={({ field: { onChange } }) => (
                <Select
                  className="react-select-common react-select-md w-100"
                  placeholder=""
                  value={listChatGpt?.find((c) => c.value === watch("agent"))}
                  options={listChatGpt}
                  onChange={val => {
                    setValue("agent", val.value)
                    onChange(val.value)
                  }}
                  classNamePrefix="react-select-custom"
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              )}
            />
          </FormDate>
          <FormDate className='w-100 mb-0'>
            <TitleNoteCommon
              dataFor={'dialog'} 
              title="Dialog Partner" 
              content=""
            />
            <Controller
              name="dialog"
              control={control}
              render={({ field: { onChange } }) => (
                <Select
                  className="react-select-common react-select-md w-100"
                  placeholder=""
                  value={listChatGpt?.find((c) => c.value === watch("dialog"))}
                  options={listChatGpt}
                  onChange={val => {
                    setValue("dialog", val.value)
                    onChange(val.value)
                  }}
                  classNamePrefix="react-select-custom"
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                />
              )}
            />
          </FormDate>
          <WrapStatement>
            <FormDate className='w-100 mb-0'>
              <TitleNoteCommon
                dataFor={'statements'} 
                title="Max # Statements" 
                content=""
              />
              <Controller
                name="statement"
                control={control}
                render={({ field }) => (
                  <Input
                    type='number'
                    name='statement'
                    placeholder=""
                  />
                )}
              />
            </FormDate>
            <FormDate className='w-100 mb-0'>
              <TitleNoteCommon
                dataFor={'iteration'} 
                title="# Iteration" 
                content=""
              />
              <Controller
                name="iteration"
                control={control}
                render={({ field }) => (
                  <Input
                    type='number'
                    name='iteration'
                    placeholder=""
                  />
                )}
              />
            </FormDate>
          </WrapStatement>
        </WrapForm>
      </form>
    </FormModal>
  );
};

export default ModalNewExperiment;